import React, {useState} from 'react';
import datasetExtractor from "@Dataset/datasetExtractor";
import {activateSingleCalendar, activateStsCalendar} from "@Reducers/mobileSlice";
import formatDate from "@DateTime/functions/formatDate";
import {LocaleType} from "@/types/Locale.type";
import {useTranslation} from "@Translation/hooks/useTranslation";
import StsDatePickerCustomInput from "@Pages/stationToStation/components/StsDatePickerCustomInput";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {datePickerPopperModifiers} from "@Pages/stationToStation/constants/datePickerPopperModifiers";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch"
import {setDate} from "@Form/reducers/formSlice"
import useStsPageDatePickerClickEvent from "@Events/hooks/useStsPageDatePickerClickEvent";
import DatePickerWrapper from "@Features/datePicker/components/DatePickerWrapper";
import datasetParser from "@Dataset/datasetParser";
import {routeTransferTypes} from "@Route/features/transportType/constants/routeTransferTypes";
import Translation from "@Translation/components/Translation";

interface StationToStationDatePickerProps {
    routeId?: string,
    locale: LocaleType,
    transportType: string,
    // ? is here so this can be used with PortalMap without errors
    index?: number,
}

function StationToStationDatePicker({routeId = null, locale, transportType, index}: StationToStationDatePickerProps) {
    const pickADateLabel = useTranslation("search_results.pick_a_date")
    const dateSelectLabel = useTranslation("form.date.placeholder")
    const dispatch = useAppDispatch()
    const [date, updateDate] = useState<Date>(new Date())
    const newRouteId = routeId ?? datasetExtractor('panel-heading', index, 'route_id')
    const activateDatePickerClickEvent = useStsPageDatePickerClickEvent("datepicker")

    const {isMobile, isSmallTablet} = useAppSelector((state) => (state.page))

    const transportTypeId = datasetParser({id: `datepicker__${newRouteId}`})

    const handleChange = (date) => {
        activateDatePickerClickEvent()
        const {
            fromId,
            toId,
            departingStationSlug,
            destinationStationSlug,
            open,
        } = window;

        const selectedDate = formatDate(date)
        dispatch(setDate(selectedDate))
        if (transportTypeId && transportTypeId?.transportType) {
            open(`/${locale}/${transportType}/${departingStationSlug}-${fromId}/${destinationStationSlug}-${toId}/${selectedDate}/-/${routeTransferTypes[transportTypeId.transportType]}?adults=1#/${newRouteId}`, '_blank')
        } else {
            open(`/${locale}/${transportType}/${departingStationSlug}-${fromId}/${destinationStationSlug}-${toId}/${selectedDate}?adults=1#/${newRouteId}`, '_blank')
        }
    }

    return (
        <div>
            <DatePickerWrapper
                value={pickADateLabel.charAt(0).toUpperCase() + pickADateLabel.slice(1)}
                // open={true}
                selected={date}
                onChange={(date) => handleChange(date)}
                placeholderText={dateSelectLabel}
                className=""
                maxDate={new Date('2120-01-01')} // must set date to enable navigation with keyboard
                popperPlacement="bottom"
                popperModifiers={datePickerPopperModifiers}
                customInput={(
                    <StsDatePickerCustomInput
                        props={{
                            isMobileOrTablet: isMobile || isSmallTablet,
                            activateStsCalendar,
                            activateSingleCalendar,
                        }}
                    />
                )}
            />
        </div>
    );
}

export default StationToStationDatePicker